/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import { createAsyncThunk } from "@reduxjs/toolkit";
import * as api from '../../../services'


export const getAllSplunk = createAsyncThunk('splunk/getAllSplunk', async (params, { rejectWithValue }) => {
    try {
 
        const data = await api.splunk.getAllSplunk(params);
         return data;
    } catch (error) {
        return rejectWithValue(error.message);
    }
})

export const getAllSplunkUsers = createAsyncThunk('splunk/getAllSplunkUsers', async (params, { rejectWithValue }) => {
    try {
 
        const data = await api.splunk.getAllSplunkUsers(params);
         return data;
    } catch (error) {
        return rejectWithValue(error.message);
    }
})

export const getSplunkRecord = createAsyncThunk('splunk/getRecord', async (params, { rejectWithValue }) => {
    try {
 
        const data = await api.splunk.getSplunk(params);
         return data;
    } catch (error) {
        return rejectWithValue(error.message);
    }
})

export const getSplunkHistory = createAsyncThunk('splunk/getSplunkHistory', async (params, { rejectWithValue }) => {
    try {
 
        const data = await api.splunk.getSplunkHistory(params);
         return data;
    } catch (error) {
        return rejectWithValue(error.message);
    }
})